/* @flow */
import * as React from 'react';
import { Link } from 'react-router-dom';
import { observable, computed } from 'mobx';
import { observer, inject } from 'mobx-react';
import { Trans, translate } from 'react-i18next';
import type { TranslatorProps } from 'react-i18next';
import { ReactAccessConsumer } from 'react-access';

import AutoCompleteModel from 'models/forms/AutoCompleteModel.js';

import ElectroSelectExtra from 'forms/components/inputs/ElectroSelectExtra/ElectroSelectExtra';
import PageWrapper from 'components/PageWrapper/PageWrapper';
import FormWrapper from 'components/FormWrapper/FormWrapper';
import FormSection from 'components/FormSection/FormSection';
import ElectroResponseMessage from 'forms/components/inputs/ElectroResponseMessage';
import ElectroFileTransfer from 'forms/components/inputs/ElectroFileTransfer';
import FormControls from 'forms/components/controls/FormControls/FormControls';
import CentralForm from 'components/CentralForm/CentralForm';

import { autoCompleteTradingAccounts } from 'api/forms.js';

import { makeFields, assetCreate } from './setUpMultipleAssetForm';
import { createMultipleOwnedAsset } from 'permissions/asset';

type TypeProps = {|
  mode: string,
  assetData: Object,
|} & TranslatorProps;

@translate()
@inject('actionDrawerStore', 'accountStore', 'assetStore', 'locationChooserStore')
@observer
export default class MultipleAssetForm extends React.Component<*> {
  @observable accountsModel: AutoCompleteModel = new AutoCompleteModel(autoCompleteTradingAccounts);

  @observable localState = {
    responseMessage: '',
    showResponseMessage: false,
    isLoading: false,
    hasSuccess: false,
    hasError: false,
  };

  @computed get form(): Object {
    const assetData: Object =
      typeof this.props.assetData === 'undefined' ? {} : this.props.assetData;
    const fields: Array<*> = makeFields(assetData, this.props.t);

    return this.props.mode === 'edit' ? null : assetCreate(fields, this.localState, this.props.t);
  }

  renderForm() {
    const form: Object = this.form;
    const accountsModel: Object = this.accountsModel;
    const t: Function = this.props.t;

    return (
      <React.Fragment>
        <PageWrapper isFlex={false}>
          <ElectroResponseMessage localState={this.localState} />
          <FormWrapper form={form}>
            {/* ================| DOWNLOAD CSV TEMPLATE |================ */}
            {/* <FormSection form={form} section="downloadCsvTamplate">
                            <p>
                                Download the CSV template and complete by entering in all<br />
                                the information regarding multiple assets you wish to add.
                            </p>
                            <Button
                                variant="contained"
                                color="primary">
                                CSV TEMPLATE
                            </Button>
                        </FormSection> */}
            {/* ================| CHOOSE ACCOUNT |================ */}
            <FormSection form={form} section="chooseAccount">
              <ElectroSelectExtra
                field={form.$('chooseAccount.tradingAccount')}
                form={form}
                formName="chooseAccount"
                labelKey="name"
                props={{
                  model: accountsModel,
                }}
              />
            </FormSection>
            {/* ================| UPLOAD CSV |================ */}
            <FormSection form={form} section="uploadCsv">
              <ElectroFileTransfer field={form.$('uploadCsv.csvFile')} variant="upload" />
            </FormSection>
            <FormControls
              buttonText={
                this.props.mode === 'edit'
                  ? t('general:actions.update')
                  : t('general:actions.upload')
              }
              form={form}
            />
          </FormWrapper>
        </PageWrapper>
      </React.Fragment>
    );
  }

  renderCustomerForm() {
    const t: Function = this.props.t;

    return (
      <CentralForm>
        <h1>{t('general:assets.labels.multiple_upload')}</h1>
        <Trans i18nKey="general:assets.messages.multiple_assets_customer" parent="p">
          {process.env.REACT_APP_PORTAL_NAME}
        </Trans>
        <Link
          to={{
            pathname: '/support',
            state: { id: 'Upload My Asset List', redirectTo: 'assets' },
          }}
        >
          {t('general:assets.labels.multiple_request')}
        </Link>
      </CentralForm>
    );
  }

  render(): React.Element<*> {
    return (
      <ReactAccessConsumer>
        {authorizeAccess => {
          return authorizeAccess(createMultipleOwnedAsset)
            ? this.renderForm()
            : this.renderCustomerForm();
        }}
      </ReactAccessConsumer>
    );
  }
}
